<script setup lang="ts">
import {ref} from "vue";
import AllCourseItem from "components/dialog/common/innner/AllCourseItem.vue";
import {IncludeCourse} from "@/types";
import {CourseService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import {Search} from "@element-plus/icons-vue";

const visible = ref(false)
const id = ref(0)
const title = ref('')
const type = ref(1)

const courses = ref<IncludeCourse[]>([])

const init = async (_type: number, _id: number) => {
  id.value = _id
  type.value = _type
  title.value = ''
  try {
    const res = await CourseService.getAllCourseList({
      id: id.value,
      type: type.value,
    })
    if (res.data.code === 200) {
      courses.value = res.data.data || []
      visible.value = true
    } else {
      ElNotification.error({
        title: "获取课程列表失败",
        message: res.data.msg,
        type: "error",
      })
    }
  } catch (error) {
    console.warn(error);
  }
}

const hide = () => {
  visible.value = false
}

const emit = defineEmits(["onAddCourse", "onRemoveCourse"])

const onAdd = (item: IncludeCourse) => {
  emit("onAddCourse", item.id)
}

const onRemove = (item: IncludeCourse) => {
  emit("onRemoveCourse", item.id)
}

const onSearch = async () => {
  try {
    const res = await CourseService.getAllCourseList({
      id: id.value,
      type: type.value,
      title: title.value,
    })
    if (res.data.code === 200) {
      courses.value = res.data.data || []
    } else {
      ElNotification.error({
        title: "获取课程列表失败",
        message: res.data.msg,
        type: "error",
      })
    }
  } catch (error) {
    console.warn(error);
  }
}

defineExpose({
  init, hide
})
</script>

<template>
  <el-dialog v-model="visible" :show-close="false" class="my-rounded-dialog" align-center @close="hide">
    <div class="flex items-center px-1rem mb-1.5rem">
      <div class="text-#000000d9 mr-3rem">课程目录</div>
      <el-input
          class="my-rounded-full"
          v-model="title" style="width: 240px" placeholder="请输入课程标题"
          :suffix-icon="Search" @change="onSearch"></el-input>
      <div class="text-1.25em font-bold ml-1rem">组合课只允许添加付费课程</div>
    </div>
    <all-course-item
        v-for="(course, index) in courses"
        @on-add="onAdd"
        @onRemove="onRemove"
        :item="course"
        :darker="index % 2 === 1"/>
    <div class="mt-1rem flex justify-center">
      <el-button type="primary" @click="hide">取消</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
.my-rounded-full {
  --el-border-radius-base: 9999px;
}
</style>

<style>
.my-rounded-dialog {
  --el-dialog-border-radius: 16px;
}
</style>
